export class DateFilter {
  firstDate: Date;
  lastDate: Date;
  dates: Date[];
}
